import TitleUpdater from '../../../../../utils/TitleUpdater';
import AITechnologyStack from './AITechnologyStack';
import EnterpriseModelShowcase from './EnterpriseModelShowcase';
import AIIndustrySolutions from './AIIndustrySolutions';
import WhyChoosePTKCS from './WhyChoosePTKCS';
import AIDevelopmentFaqs from './AIDevelopmentFaqs';
import EnterpriseAIServices from './EnterpriseAIServices';
import NewIntro from './NewIntro';

export default function AIDevelopment() {
  return (<main className="font-['Be_Vietnam_Pro']" style={{ background: '#F5F2EE', color: '#171717', overflow: 'hidden' }}>
      <TitleUpdater title="AI Development" />
      <NewIntro />
      <EnterpriseAIServices />
      <EnterpriseModelShowcase />
      <AITechnologyStack />
      {/* <WhyChoosePTKCS /> */}
      <AIIndustrySolutions />
      <AIDevelopmentFaqs />
    </main>);
}
